import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"
import { isEmpty } from "@ui-seeker/utils";

import StockAssortmentDetailsEvolutionChartToolbar from "./Toolbar";
import {useStockAssortmentWidgetsEvolutionChartData} from "./@hooks";


export default function StockAssortmentDetailsWidgetsEvolutionChart() {

    const { dataEvolution, dataEvolutionKeys, isLoadingDataEvolution, label, dateRange, onChange, resetEvolutionData } = useStockAssortmentWidgetsEvolutionChartData()

    if (isEmpty(dataEvolution) || isLoadingDataEvolution) return <></>

    return <ModalSeeker
        hideActions
        id="evolution-details-chart1"
        isOpen={!isEmpty(dataEvolution)}
        title={` Stock and Assortment Percentage Evolution for ${label}`}
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            data={dataEvolution}
            title={<Box id="evolution-chart"></Box>}
            pdfProps={{
                titlePDF:`Stock and Assortment Percentage Evolution for ${label}`
            }}
            series={dataEvolutionKeys.map(key => ({
                name: key, yField: key,
                xField: "date",
                connect: true,
            }))}
            chartProps={{
                numberFormat: "#.'%'",
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                },
                yAxis: {
                    numberFormat: "#'%'"
                }
            }}
            cardProps={{ actions: <StockAssortmentDetailsEvolutionChartToolbar dateRange={dateRange} onChange={onChange} /> }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}